module.exports = __webpack_public_path__ + "media/src/images/logos/whatsapp-bb368767dd1eb989c2412932cbe20758.png";